import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import {
  fetchLoincData,
  removeLoincRecord,
  fetchLoincById,
} from "../services/loincCodes-service";
import { fetchConditions } from "../services/conditions-service";
import { loincHeadCells } from "../util/headcells-util";
import { showPopupDetails } from "../util/common";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { LTRB } from "../util/component-codes";
import { FixedSizeList } from "react-window";
import Cookies from "js-cookie";
import { removeLoincForIDSS } from "../services/ids-service";

const codeSystem = ["LOINC", "PLT", "Not Specified"];
const LOINCCodes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleError = () => {
    let value = false;
    if (location?.state?.isAdded != null) {
      value = !location?.state?.isAdded;
    } else if (location?.state?.isUpdated != null) {
      value = !location?.state?.isUpdated;
    }
    return value;
  };

  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState(
    location?.state?.message != null ? location?.state?.message : null
  );
  const [filter, setFilter] = useState(
    location?.state?.filter ? location?.state?.filter : {}
  );
  const [isAdded, setIsAdded] = useState(
    location?.state?.isAdded != null ? location?.state?.isAdded : false
  );
  const [isUpdated, setIsUpdated] = useState(
    location?.state?.isUpdated != null ? location?.state?.isUpdated : false
  );
  const [isError, setIsError] = useState(handleError());
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loincData, setLoincData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(
    location?.state?.pageNo ? location?.state?.pageNo : 0
  );
  const [isFetchError, setIsFetchError] = useState(false);
  const [loincDetails, setLoincDetails] = useState(null);
  const [conditionCheckedValues, setConditionCheckedValues] = useState(
    location?.state?.filter?.condition ? location?.state?.filter?.condition : []
  );
  const [testMethodCheckedValues, setTestMethodCheckedValues] = useState(
    location?.state?.filter?.testMethod
      ? location?.state?.filter?.testMethod
      : []
  );
  const [scaleTypeCheckedValues, setScaleTypeCheckedValues] = useState(
    location?.state?.filter?.scaleType ? location?.state?.filter?.scaleType : []
  );
  const [codeSystemCheckedValues, setCodeSystemCheckedValues] = useState(
    location?.state?.filter?.codeSystem
      ? location?.state?.filter?.codeSystem
      : []
  );
  const [specimenSourceCheckedValues, setSpecimenSourceCheckedValues] =
    useState(
      location?.state?.filter?.specimenSource
        ? location?.state?.filter?.specimenSource
        : []
    );
  const [conditions, setConditions] = useState([]);
  const [testMethodValues, setTestMethodValues] = useState([]);
  const [scaleTypeValues, setScaleTypeValues] = useState([]);
  const [specimenSourceValues, setSpecimenSourceValues] = useState([]);

  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleCloseDetailsModal = () => setShowDetailsModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const handleCheckboxChange = (
    newValue,
    conditionCheckedValues,
    setConditionCheckedValues,
    filter
  ) => {
    let copyCheckedValues = [...conditionCheckedValues];

    if (copyCheckedValues.includes(newValue)) {
      copyCheckedValues = copyCheckedValues.filter((item) => item !== newValue);
    } else {
      copyCheckedValues = [...copyCheckedValues, newValue];
    }
    setConditionCheckedValues(copyCheckedValues);
    setFilterField(filter, copyCheckedValues);
  };

  const handleAdd = () => {
    navigate("/loincForm", {
      state: {
        filter: filter,
        pageNo: pageNo,
      },
    });
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    navigate("/loincForm", {
      state: {
        action: "update",
        selectedRow: selectedRow,
        filter: filter,
        pageNo: pageNo,
      },
    });
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getLoincData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setConditionCheckedValues([]);
    setTestMethodCheckedValues([]);
    setScaleTypeCheckedValues([]);
    setCodeSystemCheckedValues([]);
    setSpecimenSourceCheckedValues([]);
    setFilter({});
  };

  const urlWithParams = (filter) => {
    let loincCode = filter?.searchText ? filter?.searchText : "";
    let conditions = filter?.condition?.length > 0 ? filter?.condition : [];
    let specimenSource =
      filter?.specimenSource?.length > 0 ? filter?.specimenSource : [];
    let scaleType = filter?.scaleType?.length > 0 ? filter?.scaleType : [];
    let codeSystem = filter?.codeSystem?.length > 0 ? filter?.codeSystem : [];
    let testMethod = filter?.testMethod?.length > 0 ? filter?.testMethod : [];
    let isActive = [];

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let filterPayload = {
      loincCode: loincCode,
      condition: conditions,
      specimenSource: specimenSource,
      scaleType: scaleType,
      codeSystem: codeSystem,
      testMethod: testMethod,
      isActive: isActive,
    };
    return filterPayload;
  };

  const getLoincData = useCallback(
    async (filter) => {
      let response = await fetchLoincData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setLoincData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const removeLoinc = async () => {
    let data1 = await removeLoincForIDSS(selectedRow?.loincCode);
    console.log(data1);
    if (data1?.statusCode === "200") {
      let response = await removeLoincRecord(selectedRow.loincId);
      if (response !== ERROR_MSG) {
        setIsDeleted(true);
        setSelectedRow(null);
      } else {
        setIsError(true);
      }
    } else {
      setIsError(true);
      setAlertMessage(
        "Error, synchronization unsuccessful with IDSS LOINC Table: " +
          data1?.message
      );
    }
    handleRemoveWarningModalClose();
  };

  const getConditions = async () => {
    let response = await fetchConditions();

    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        let sortedData = data.sort((a, b) =>
          a.conditionName > b.conditionName ? 1 : -1
        );
        setConditions(sortedData);
      } else {
        setIsFetchError(true);
        setIsError(true);
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const getLoincDetails = async (loincId) => {
    let response = await fetchLoincById(loincId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setLoincDetails(data);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
        setShowDetailsModal(true);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(LTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted LOINC record";
    } else if (isAdded) {
      return "New LOINC code has been successfully added!";
    } else if (isUpdated) {
      return "LOINC code has been successfully updated!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const getDropdownValues = async (tableName) => {
    let response = await fetchCodeSetTable(tableName);
    if (response.ok) {
      let data = await response.json();
      let sortedValues = data?.refTableValues.sort((a, b) =>
        a.reference_code > b.reference_code ? 1 : -1
      );
      if (tableName === "Test Method") {
        setTestMethodValues(sortedValues);
      } else if (tableName === "Scale Type") {
        setScaleTypeValues(sortedValues);
      } else if (tableName === "Specimen Source") {
        setSpecimenSourceValues(sortedValues);
      }
    }
  };

  useEffect(() => {
    getLoincData(filter);
  }, [pageNo, recordsPerPage, getLoincData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getLoincData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getLoincData]);

  useEffect(() => {
    getConditions();
    getDropdownValues("Test Method");
    getDropdownValues("Scale Type");
    getDropdownValues("Specimen Source");
  }, []);

  useEffect(() => {
    if (pageNo >= loincData?.totalPages) {
      loincData?.totalPages !== 0 && setPageNo(loincData?.totalPages - 1);
    }
    // else setPageNo(0)
  }, [loincData]);

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">LOINC Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the LOINC codes available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={loincHeadCells}
          rows={loincData?.genericList}
          pages={loincData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New LOINC"
          addButtonAction={handleAdd}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isLoincTable={true}
          getLoincDetails={getLoincDetails}
          filter={filter}
          pageNo={pageNo}
        />
      </Container>

      <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailsModal}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            <div className="cardBody">
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}details-icon.png`}
                style={{
                  width: "32px",
                  height: "32px",
                  marginRight: "15px",
                }}
                alt=""
              ></img>
              LOINC Details
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <Row>
            <Col sm={3}>
              <div className="repLoincModalTitle">LOINC Code:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.loincCode)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Condition:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.conditionName)}
              </div>
            </Col>
            <Col sm={4}>
              <div className="repLoincModalTitle">Test Method:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.testMethod)}
              </div>
            </Col>
            {loincDetails?.conditionName === "Syphilis" && (
              <Col>
                <div className="repLoincModalTitle">RE Test Type:</div>
                <div className="repLoincModalSubtitle">
                  {showPopupDetails(loincDetails?.testType)}
                </div>
              </Col>
            )}
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "20px" }}></hr>
          <Row>
            <Col>
              {loincDetails?.lookupCondition ? (
                <FormControlLabel
                  control={<Checkbox checked={true} disabled />}
                  label="LOINC is Not Condition Specific in Rules Engine"
                />
              ) : (
                <FormControlLabel
                  control={<Checkbox checked={false} disabled />}
                  label="LOINC is Not Condition Specific in Rules Engine"
                />
              )}
            </Col>
            <Col>
              {loincDetails?.isAcceptableByRE ? (
                <FormControlLabel
                  control={<Checkbox checked={true} disabled />}
                  label="Acceptable by Rules Engine"
                />
              ) : (
                <FormControlLabel
                  control={<Checkbox checked={false} disabled />}
                  label="Acceptable by Rules Engine"
                />
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col>
              <div className="repLoincModalTitle">
                Test performed LOINC Long name:
              </div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.loincLongName)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col>
              <div className="repLoincModalTitle">LOINC Short Name:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.loincShortName)}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row>
            <Col sm={4}>
              <div className="repLoincModalTitle">Specimen Source:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.specimenSource)}
              </div>
            </Col>
            <Col sm={4}>
              <div className="repLoincModalTitle">Scale Type:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.scaleType)}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Property:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.property)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={4}>
              <div className="repLoincModalTitle">Code System:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.codeSystem)}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Time Aspect:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.timeAspect)}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Status:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(
                  loincDetails?.isActive ? "Active" : "Inactive"
                )}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row>
            <Col sm={4}>
              <div className="repLoincModalTitle">Result Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.resultInterpretation)}
              </div>
            </Col>
            <Col sm={2}>
              <div className="repLoincModalTitle">Units:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.qnInterpretations?.units)}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Reference Range:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(
                  loincDetails?.qnInterpretations?.referenceRange
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={4}>
              <div className="repLoincModalTitle">BLOQ Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(
                  loincDetails?.qnInterpretations?.bloqInterpretation
                )}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">ALOQ Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(
                  loincDetails?.qnInterpretations?.aloqInterpretation
                )}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginBottom: "40px" }}>
            <Col className="repLoincModalTitle">
              Qn Interpretation Decision Table
            </Col>
          </Row>
          <Row style={{ marginBottom: "20px" }}>
            <Col className="repLoincModalTitle">Value:</Col>
            <Col className="repLoincModalTitle">Value:</Col>
            <Col className="repLoincModalTitle">Result (output)</Col>
          </Row>
          <Row style={{ marginBottom: "20px" }}>
            <Col className="repLoincModalSubtitle">
              {
                loincDetails?.qnInterpretations?.qnInterpretationList[0]
                    ?.qnInterpretationConditions?.find(
                        (obj) => obj.seqNum == 1
                    )?.operator
              }
            </Col>
            <Col className="repLoincModalSubtitle">
              {
                loincDetails?.qnInterpretations?.qnInterpretationList[0]
                    ?.qnInterpretationConditions?.find(
                        (obj) => obj.seqNum == 2
                    )?.operator
              }
            </Col>
            <Col className="repLoincModalSubtitle"></Col>
          </Row>
          {loincDetails?.qnInterpretations?.qnInterpretationList?.map(
            (item) => {
              item?.qnInterpretationConditions.sort(
                (a, b) => a.seqNum - b.seqNum
              );
              return (
                <Row>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showPopupDetails(
                        item.qnInterpretationConditions[0]?.valueRHS
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showPopupDetails(
                        item.qnInterpretationConditions[1]?.valueRHS
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showPopupDetails(
                        item.qnInterpretationActions[0]?.valueRHS
                      )}
                    </div>
                  </Col>
                </Row>
              );
            }
          )}
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginBottom: "40px" }}>
            <Col>
              <div className="repLoincModalTitle">Admin Comments:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(loincDetails?.comments)}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove LOINC
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this LOINC Code from the Table?
              <br />
              <br />
              The LOINC will no longer be visible on the screen and all
              rules/conditions associated with this LOINC will also be deleted
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeLoinc}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search LOINC"
                value={filter.searchText ? filter.searchText : ""}
                onChange={(e) => setFilterField("searchText", e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion disablegutters="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Conditions</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        conditions.sort((a, b) =>
                          a.conditionName.localeCompare(b.conditionName)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={conditionCheckedValues.includes(
                                  conditions[index].conditionName
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    conditions[index].conditionName,
                                    conditionCheckedValues,
                                    setConditionCheckedValues,
                                    "condition"
                                  )
                                }
                                name={conditions[index].conditionName}
                              />
                            }
                            label={conditions[index].conditionName}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Test Method</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        testMethodValues.sort((a, b) =>
                          a.reference_code.localeCompare(b.reference_code)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={testMethodCheckedValues.includes(
                                  testMethodValues[index].reference_code
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    testMethodValues[index].reference_code,
                                    testMethodCheckedValues,
                                    setTestMethodCheckedValues,
                                    "testMethod"
                                  )
                                }
                                name={testMethodValues[index].reference_code}
                              />
                            }
                            label={
                              testMethodValues[index].reference_Code_description
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Specimen Source</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        specimenSourceValues.sort((a, b) =>
                          a.reference_Code_description.localeCompare(
                            b.reference_Code_description
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={specimenSourceCheckedValues.includes(
                                  specimenSourceValues[index]
                                    .reference_Code_description
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    specimenSourceValues[index]
                                      .reference_Code_description,
                                    specimenSourceCheckedValues,
                                    setSpecimenSourceCheckedValues,
                                    "specimenSource"
                                  )
                                }
                                name={
                                  specimenSourceValues[index]
                                    .reference_Code_description
                                }
                              />
                            }
                            label={
                              specimenSourceValues[index]
                                .reference_Code_description
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div className="bold">Scale Type</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        scaleTypeValues.sort((a, b) =>
                          a.reference_code.localeCompare(b.reference_code)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={scaleTypeCheckedValues.includes(
                                  scaleTypeValues[index].reference_code
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    scaleTypeValues[index].reference_code,
                                    scaleTypeCheckedValues,
                                    setScaleTypeCheckedValues,
                                    "scaleType"
                                  )
                                }
                                name={scaleTypeValues[index].reference_code}
                              />
                            }
                            label={
                              scaleTypeValues[index].reference_Code_description
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <div className="bold">Code System</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    {codeSystem.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={codeSystemCheckedValues.includes(item)}
                              onChange={() =>
                                handleCheckboxChange(
                                  item,
                                  codeSystemCheckedValues,
                                  setCodeSystemCheckedValues,
                                  "codeSystem"
                                )
                              }
                              name={item}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />

              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LOINCCodes;
